//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    items: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      sliderOptions: {
        arrows: false,
        slidesToShow: 3,
        infinite: false,
        slidesToScroll: 1,
        adaptiveHeight: true,
        centerMode: false,
        dots: false,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
    };
  },
};
